// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22trA","importantInfo":"styles_importantInfo__r_ntq"};